import axios from "axios";
import config from '../config'

export function postUpdateLands(address) {
    let updateUrl = `${config.URL}/api/lands/update/${address}/`;
    return axios.post(updateUrl).then((response) => {
            return response.data.data
        })
}